export const REDIRECT = 'REDIRECT';

export function redirect(route, history) {
    return {
        type: REDIRECT,
        route,
        history
    }
}
